"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackableLinkFields = exports.CacheableLinkFields = exports.CacheableLinkTypes = exports.EditMode = exports.getAllLinkTypesForProps = exports.LinkTypes = void 0;
var LinkTypes = {
  PAGE: 'page',
  EMAIL: 'email',
  URL: 'url',
  FILE: 'file',
  EMAIL_SUBSCRIPTION: 'email_subscription',
  MEETING: 'meeting',
  ANCHOR: 'anchor',
  NONE: 'no_link'
};
exports.LinkTypes = LinkTypes;

var getAllLinkTypesForProps = function getAllLinkTypesForProps() {
  return Object.keys(LinkTypes).map(function (linkType) {
    return LinkTypes[linkType];
  });
};

exports.getAllLinkTypesForProps = getAllLinkTypesForProps;
var EditMode = {
  PREVIEW: 'preview',
  EDIT: 'edit'
};
exports.EditMode = EditMode;
var CacheableLinkTypes = [LinkTypes.PAGE, LinkTypes.FILE, LinkTypes.MEETING];
exports.CacheableLinkTypes = CacheableLinkTypes;
var CacheableLinkFields = ['linkDisplayName', 'linkType', 'fileMeta'];
exports.CacheableLinkFields = CacheableLinkFields;
var TrackableLinkFields = ['noFollow', 'externalLink', 'linkType'];
exports.TrackableLinkFields = TrackableLinkFields;